/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Fields/view.blocks to change it.
import Address from './Address/index'
import Description from './Description/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Fields({
  children,
  viewPath = "/DesignSystem/DataVaxiomOtherProfessionalsEdit/Content/Email/Emails/Content/Email/Edit/Content/Fields"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="Fields.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<Address
  viewPath={`${viewPath}/Address`}
/>
<Description
  viewPath={`${viewPath}/Description`}
/>
</div>
{children}
</React.Fragment>)
}